// clipEntitySlice.ts
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { Clip } from '../types';

//~ Keep a reference to this slice's name for cleanup in case of persistReducer usage
export const name = 'clips';

//~ Initialize your state here
const clipsAdapter = createEntityAdapter<Clip>();

interface ClipState extends ReturnType<typeof clipsAdapter.getInitialState> {
    selectedClipId: string;
}

const initialState: ClipState = {
    selectedClipId: '',
    ...clipsAdapter.getInitialState(),
};

export const clipSlice = createSlice({
    name,
    initialState,
    reducers: {
        //~ Define your synchronous reducers here
        setSelectedClipId: (state, action) => {
            state.selectedClipId = action.payload;
        },
        clearSelectedClipId: (state) => {
            state.selectedClipId = '';
        },
    },
    selectors: {
        //~ Define your selectors here
        selectSelectedClipId: (sliceState) => sliceState.selectedClipId,
        selectIsClipSelected: (sliceState) => !!sliceState.selectedClipId,
    },
});

//~ Export defined synchronous reducers here
export const { setSelectedClipId, clearSelectedClipId } = clipSlice.actions;
export const clipSelectors = clipsAdapter.getSelectors();

//~ Export defined selectors here
export const { selectSelectedClipId, selectIsClipSelected } =
    clipSlice.selectors;

export const clipReducer = clipSlice.reducer;
export default clipReducer;
